{
  "messages": {
    "header": "Messages",
    "open-template": "Open Template",
    "render-template": "Render Template",
    "select-template": {
      "label": "Template",
      "placeholder": "Select template..."
    }
  }
}
